import { useState, useMemo } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useProperties } from '../hooks/useProperties.js';
import PropertyCard from '../components/property/PropertyCard.jsx';
import SearchBar from '../components/property/SearchBar.jsx';
import { SkeletonGrid } from '../components/ui/Skeleton.jsx';
import { PROP_TYPES, SORTS } from '../data/constants.js';
import { BRAND } from '../data/constants.js';

const AMEN_FILTERS = [['cochera','Cochera'],['balcon','Balcón'],['terraza','Terraza'],['patio','Patio'],['jardin','Jardín'],['pileta','Pileta'],['parrilla','Parrilla'],['sum','SUM'],['gym','Gimnasio'],['seguridad','Seguridad 24h']];
const ROOMS = [['','Todos'],['1','1+'],['2','2+'],['3','3+'],['4','4+']];

export default function Listing() {
  const [sp, setSp] = useSearchParams();
  const f = {
    op:     sp.get('op')     || 'venta',
    tipo:   sp.get('tipo')   || '',
    zona:   sp.get('zona')   || '',
    min:    sp.get('min')    || '',
    max:    sp.get('max')    || '',
    amb:    sp.get('amb')    || '',
    dorm:   sp.get('dorm')   || '',
    credito:sp.get('credito')==='1',
    sort:   sp.get('sort')   || 'relevancia',
    amen:   sp.get('amen')   ? sp.get('amen').split(',') : [],
  };
  const set = (patch) => {
    const next = { ...f, ...patch };
    const p = new URLSearchParams();
    if (next.op)      p.set('op', next.op);
    if (next.tipo)    p.set('tipo', next.tipo);
    if (next.zona)    p.set('zona', next.zona);
    if (next.min)     p.set('min', next.min);
    if (next.max)     p.set('max', next.max);
    if (next.amb)     p.set('amb', next.amb);
    if (next.dorm)    p.set('dorm', next.dorm);
    if (next.credito) p.set('credito','1');
    if (next.sort && next.sort !== 'relevancia') p.set('sort', next.sort);
    if (next.amen && next.amen.length) p.set('amen', next.amen.join(','));
    setSp(p);
  };

  const [view, setView]       = useState('grid');
  const [sheetOpen,setSheet]  = useState(false);
  const [showAdv, setShowAdv] = useState(false);

  const { data, total, loading, error } = useProperties(f);

  const activeChips = useMemo(() => {
    const chips = [];
    if (f.tipo)   chips.push({ label: PROP_TYPES[f.tipo],                clear: () => set({tipo:''}) });
    if (f.zona)   chips.push({ label: '📍 '+f.zona,                      clear: () => set({zona:''}) });
    if (f.min)    chips.push({ label: 'Desde US$ '+Number(f.min).toLocaleString('es-AR'), clear: () => set({min:''}) });
    if (f.max)    chips.push({ label: 'Hasta US$ '+Number(f.max).toLocaleString('es-AR'), clear: () => set({max:''}) });
    if (f.amb)    chips.push({ label: f.amb+'+ amb',                      clear: () => set({amb:''}) });
    if (f.dorm)   chips.push({ label: f.dorm+'+ dorm',                    clear: () => set({dorm:''}) });
    if (f.credito)chips.push({ label: 'Apto crédito',                     clear: () => set({credito:false}) });
    f.amen.forEach(a => { const m=AMEN_FILTERS.find(x=>x[0]===a); if(m) chips.push({label:m[1], clear:()=>set({amen:f.amen.filter(x=>x!==a)})}); });
    return chips;
  }, [sp.toString()]);

  const clearAll = () => set({tipo:'',zona:'',min:'',max:'',amb:'',dorm:'',credito:false,amen:[]});

  const Filters = () => (
    <div className="fc">
      <div className="fc-group">
        <label className="fc-glabel">Operación</label>
        <div className="seg fc-seg">
          <button aria-pressed={f.op==='venta'}    onClick={()=>set({op:'venta'})}>Comprar</button>
          <button aria-pressed={f.op==='alquiler'} onClick={()=>set({op:'alquiler'})}>Alquilar</button>
        </div>
      </div>
      <div className="fc-group">
        <label className="fc-glabel">Tipo</label>
        <div className="fc-pills">
          <button className={"fc-pill"+(!f.tipo?' on':'')} onClick={()=>set({tipo:''})}>Todos</button>
          {Object.entries(PROP_TYPES).map(([k,v])=>(
            <button key={k} className={"fc-pill"+(f.tipo===k?' on':'')} onClick={()=>set({tipo:f.tipo===k?'':k})}>{v}</button>
          ))}
        </div>
      </div>
      <div className="fc-group">
        <label className="fc-glabel">Precio (USD)</label>
        <div className="fc-row">
          <div className="fc-field"><label>Mínimo</label><input className="input" type="number" placeholder="0" value={f.min} onChange={e=>set({min:e.target.value})} /></div>
          <div className="fc-field"><label>Máximo</label><input className="input" type="number" placeholder="Sin límite" value={f.max} onChange={e=>set({max:e.target.value})} /></div>
        </div>
      </div>
      <div className="fc-group">
        <label className="fc-glabel">Ambientes</label>
        <div className="fc-pills">{ROOMS.map(([v,l])=><button key={'a'+v} className={"fc-pill"+(f.amb===v?' on':'')} onClick={()=>set({amb:v})}>{l}</button>)}</div>
      </div>
      <div className="fc-group">
        <label className="fc-glabel">Dormitorios</label>
        <div className="fc-pills">{ROOMS.map(([v,l])=><button key={'d'+v} className={"fc-pill"+(f.dorm===v?' on':'')} onClick={()=>set({dorm:v})}>{l}</button>)}</div>
      </div>
      <button className="fc-advtoggle" onClick={()=>setShowAdv(s=>!s)} aria-expanded={showAdv}>
        Más filtros {showAdv ? '▲' : '▼'}
      </button>
      {showAdv && (
        <div className="fc-adv">
          <label className="fc-check">
            <input type="checkbox" checked={f.credito} onChange={e=>set({credito:e.target.checked})} />
            <span className="fc-box">{f.credito && '✓'}</span> Apto crédito
          </label>
          <div className="fc-glabel" style={{marginTop:14}}>Características</div>
          <div className="fc-amen">
            {AMEN_FILTERS.map(([k,l])=>(
              <button key={k} className={"fc-pill sm"+(f.amen.includes(k)?' on':'')}
                onClick={()=>set({amen:f.amen.includes(k)?f.amen.filter(x=>x!==k):[...f.amen,k]})}>{l}</button>
            ))}
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className="listado">
      <div className="list-top">
        <div className="container-wide">
          <nav className="crumbs" aria-label="Ruta">
            <Link to="/">Inicio</Link> › <Link to={"/buscar?op="+f.op}>{f.op==='alquiler'?'Alquilar':'Comprar'}</Link>
            {f.tipo && <> › <span>{PROP_TYPES[f.tipo]}</span></>}
          </nav>
          <h1 className="list-h1">{f.zona||'Zona Sur'} — {f.op==='alquiler'?'Alquiler':'Venta'}</h1>
          <div className="list-hsearch"><SearchBar variant="compact" initial={{op:f.op,tipo:f.tipo,zona:f.zona}} /></div>
        </div>
      </div>
      <div className="container-wide list-layout">
        <aside className="list-side">
          <div className="side-inner">
            <div className="side-head"><span>Filtros</span><span>⚙</span></div>
            <Filters />
          </div>
        </aside>
        <main className="list-main" id="resultados">
          <div className="res-bar">
            <div className="res-count"><strong className="tnum">{total}</strong><span> propiedades</span></div>
            <div className="res-tools">
              <div className="res-sort">
                <label htmlFor="sortsel" className="res-sort-l">Ordenar</label>
                <div className="fc-selwrap sort-sel">
                  <select id="sortsel" className="select" value={f.sort} onChange={e=>set({sort:e.target.value})}>
                    {SORTS.map(s=><option key={s.value} value={s.value}>{s.label}</option>)}
                  </select>
                </div>
              </div>
              <div className="seg viewseg">
                <button aria-pressed={view==='grid'} aria-label="Grilla" onClick={()=>setView('grid')}>⊞</button>
                <button aria-pressed={view==='list'} aria-label="Lista"  onClick={()=>setView('list')}>☰</button>
              </div>
            </div>
          </div>
          {activeChips.length > 0 && (
            <div className="chips-row">
              {activeChips.map((c,i)=>(
                <span key={i} className="chip">{c.label}
                  <button onClick={c.clear} aria-label={"Quitar "+c.label}>✕</button>
                </span>
              ))}
              <button className="chips-clear" onClick={clearAll}>Limpiar todo</button>
            </div>
          )}
          {loading ? <SkeletonGrid />
            : error ? <div className="empty"><h3>Error al cargar</h3><p>{error}</p><button className="btn btn-ghost" onClick={()=>setSp(sp)}>Reintentar</button></div>
            : data.length === 0 ? (
              <div className="empty">
                <div className="empty-ic">🔍</div>
                <h3>No encontramos propiedades con estos filtros</h3>
                <p>Probá ampliar la búsqueda o cambiá la zona.</p>
                <div className="empty-actions">
                  <button className="btn btn-ghost" onClick={clearAll}>Limpiar filtros</button>
                  <a className="btn btn-primary" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">💬 Consultanos</a>
                </div>
              </div>
            ) : view === 'list'
              ? <div className="list-stack">{data.map(p=><PropertyCard key={p.id} p={p} variant="list" />)}</div>
              : <div className="feat-grid">{data.map(p=><PropertyCard key={p.id} p={p} />)}</div>
          }
        </main>
      </div>
      <button className="fab-filters" onClick={()=>setSheet(true)}>⚙ Filtros</button>
      {sheetOpen && (
        <div className="sheet-overlay" onClick={()=>setSheet(false)}>
          <div className="sheet" onClick={e=>e.stopPropagation()} role="dialog" aria-label="Filtros">
            <div className="sheet-grab"/>
            <div className="sheet-head"><h3>Filtros</h3><button className="iconbtn" onClick={()=>setSheet(false)} aria-label="Cerrar">✕</button></div>
            <div className="sheet-body"><Filters /></div>
            <div className="sheet-foot">
              <button className="btn btn-ghost" onClick={()=>{clearAll();setSheet(false);}}>Limpiar</button>
              <button className="btn btn-primary btn-block" onClick={()=>setSheet(false)}>Ver {total} propiedades</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
